export enum ERegisterDataType {
  INT16 = "INT16",
  UINT16 = "UINT16",
  INT32 = "INT32",
  UINT32 = "UINT32",
  FLOAT = "FLOAT",
  STRING = "STRING",
}
